{
  "JWT_URL_PARAM": "JWT",
  "DEFAULT_LANGUAGE": "en",
  "HEADER_TOKEN_AUTH": "X-Auth",
  "HTTP_STATUS_CODES": {
    "OK": 200,
    "UNAUTHORIZED": 401,
    "FORBIDDEN": 403,
    "BAD_REQ_BUSINESS_PROCESS": 422,
    "INTERNAL_SERVER_ERROR": 500
  },
  "SERVICE_ERROR_CODES": {
    "COMPOUND_DELETE_IMPOSSIBLE_DUE_TO_REF_ORG_UNIT": 4500
  },
  "MEDIA_TYPE_NAMES": {
    "png": "MEDIA_FILE_TYPES_PNG_FILE",
    "gif": "MEDIA_FILE_TYPES_GIF_FILE",
    "tif": "MEDIA_FILE_TYPES_TIFF_FILE",
    "tiff": "MEDIA_FILE_TYPES_TIFF_FILE",
    "jpg": "MEDIA_FILE_TYPES_JPG_FILE",
    "jpeg": "MEDIA_FILE_TYPES_JPG_FILE",
    "jpe": "MEDIA_FILE_TYPES_JPG_FILE",
    "pdf": "MEDIA_FILE_TYPES_PDF_FILE",
    "xls": "MEDIA_FILE_MS_OFFICE_EXCEL",
    "xlsx": "MEDIA_FILE_MS_OFFICE_EXCEL",
    "xla": "MEDIA_FILE_MS_OFFICE_EXCEL",
    "doc": "MEDIA_FILE_MS_OFFICE_WORD",
    "docx": "MEDIA_FILE_MS_OFFICE_WORD",
    "dot": "MEDIA_FILE_MS_OFFICE_WORD",
    "ppt": "MEDIA_FILE_MS_OFFICE_PPT",
    "pptx": "MEDIA_FILE_MS_OFFICE_PPT",
    "ppz": "MEDIA_FILE_MS_OFFICE_PPT",
    "pps": "MEDIA_FILE_MS_OFFICE_PPT",
    "pot": "MEDIA_FILE_MS_OFFICE_PPT",
    "mdb": "MEDIA_FILE_MS_OFFICE_ACCESS",
    "gz": "MEDIA_FILE_ARCHIVE",
    "zip": "MEDIA_FILE_ARCHIVE",
    "wmv": "MEDIA_FILE_VIDEO",
    "mpg": "MEDIA_FILE_VIDEO",
    "mpeg": "MEDIA_FILE_VIDEO",
    "avi": "MEDIA_FILE_VIDEO",
    "mov": "MEDIA_FILE_VIDEO",
    "mp4": "MEDIA_FILE_VIDEO"
  },
  "MEDIA_MAX_FILE_SIZE": 50,
  "HOME": {},
  "PSA": {
    "STATUS": {
      "TYPE_UI_NAMES": ["OPEN", "PERFORMED", "COMPLETED"],
      "FIELD_TYPE": "STRING"
    },
    "PSA_TYPE": {
      "TYPE_UI_NAMES": ["PSA", "FOLLOW_UP", "SPOT_CHECK"],
      "FIELD_TYPE": "STRING"
    },
    "TARGET_RELEVANT": {
      "TYPE_UI_NAMES": ["YES", "NO"],
      "FIELD_TYPE": "BOOLEAN"
    },
    "RESPONSIBILITY": {
      "TYPE_UI_NAMES": ["PAG", "MARKET"],
      "FIELD_TYPE": "STRING"
    },
    "LEAD_AUDITOR": {
      "FIELD_TYPE": "STRING"
    },
    "PSA_CW": {
      "FIELD_TYPE": "STRING"
    },
    "DEALER_NAME": {
      "FIELD_TYPE": "STRING",
      "MAX_LENGTH": 255
    },
    "DEALER_NUMBER": {
      "FIELD_TYPE": "STRING"
    },
    "YEAR": {
      "FIELD_TYPE": "NUMBER"
    },
    "PRMS_TICKET": {
      "FIELD_TYPE": "STRING",
      "MAX_LENGTH": 255
    }
  },
  "PSA_EDIT": {
    "CSV_CLAIMS_HEADERS": [
      "HP_NR",
      "EE_AUFT_NR",
      "ANT_NR",
      "SCHAD_POS_NR",
      "BUCHART_GW",
      "OBJKRIT_GW",
      "ANTART_GW",
      "FZ_ID_NR",
      "GS_DATUM_SCHAD",
      "REP_DAT",
      "KM",
      "KDNR",
      "S_ART",
      "ZE_RED",
      "LOHN_GS_HP",
      "LOHN_GS",
      "MAT_GS_HP",
      "MAT_GS",
      "FREMD_LOHN_GS_HP",
      "FREMD_LOHN_GS",
      "FREMD_MAT_GS_HP",
      "FREMD_MAT_GS",
      "HANDLING_GS_HP",
      "HANDLING_GS",
      "LANDING_GS_HP",
      "LANDING_GS",
      "GESAMT_GS_HP",
      "GESAMT_GS",
      "APOS_POS_NR",
      "APOS_POS_LFDN",
      "APOS_NR",
      "ZE_RED_HDL",
      "ZE_RED_IMP",
      "FR_LO_EIN_HDL",
      "FR_LO_EIN_IMP",
      "FR_LO_RED_HDL",
      "FR_LO_RED_IMP",
      "APOS_STATUS",
      "ETPOS_POS_NR",
      "ETPOS_POS_LFDN",
      "ET_ANZ_EIN_HDL",
      "ET_ANZ_RED_HDL",
      "ET_ANZ_EIN_IMP",
      "ET_ANZ_RED_IMP",
      "ET_BEZ_E",
      "ET_NR_E",
      "MAT_K_EIN_HDL",
      "MAT_K_EIN_IMP",
      "MAT_K_RED_HDL",
      "MAT_K_RED_IMP",
      "SCH_VER_E",
      "ET_STATUS",
      "APOS_BEZ_E"
    ],
    "CSV_CLAIMS_FILENAME": "claims_export.xlsx",
    "CSV_PWA_CONTRACTS_HEADERS": ["HP_NR", "FZ_ID_NR", "AUSLIEF_DAT", "MELDE_DAT", "VERTRAG_ART", "VERTRAG_Dauer"],
    "CSV_PAW_CONTRACTS_FILENAME": "paw_contracts_export.xlsx",
    "EXPORT_ZIP_FILENAME": "psa_data_export.zip"
  }
}
